import { ResultDir } from "@gant-lowcode/lowcode-types";
import { IProjectTemplate } from "../../../../../types";
import { generateStaticFiles } from "./static-files";

const gantChunkTemplate: (
  rootPaths: string[],
  pagePaths: string[],
  configPaths: string[]
) => IProjectTemplate = (
  rootPaths: string[] = ["src"],
  pagePaths = ["pages"],
  configPaths = []
) => ({
  slots: {
    root: {
      path: [rootPaths[0]],
    },
    components: {
      path: [...rootPaths, "components"],
    },
    pages: {
      path: [...rootPaths, ...pagePaths],
    },
    router: {
      path: rootPaths,
      fileName: "routes",
    },
    entry: {
      path: rootPaths,
      fileName: "lowcode-app",
    },
    constants: {
      path: [...rootPaths, "lowcode-common"],
      fileName: "constants",
    },
    utils: {
      path: [...rootPaths, "lowcode-common"],
      fileName: "utils",
    },
    i18n: {
      path: [...rootPaths, "lowcode-common"],
      fileName: "i18n",
    },
    globalStyle: {
      path: [...rootPaths, "lowcode-common"],
      fileName: "global",
    },
    htmlEntry: {
      path: ["public"],
      fileName: "index",
    },
    packageJSON: {
      path: [],
      fileName: "package",
    },
    config: {
      path: [...rootPaths, ...configPaths],
      fileName: "lowcode.config",
    },
  },

  generateTemplate(): ResultDir {
    return generateStaticFiles();
  },
});

export default gantChunkTemplate;
